import { render } from "./StoryTellingMetrics.vue?vue&type=template&id=85c4e476&scoped=true"
import script from "./StoryTellingMetrics.vue?vue&type=script&lang=js"
export * from "./StoryTellingMetrics.vue?vue&type=script&lang=js"

import "./StoryTellingMetrics.vue?vue&type=style&index=0&id=85c4e476&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85c4e476"]])

export default __exports__